
















import { Component, Prop, Vue } from 'vue-property-decorator';
import CodeCard from '@/components/code/CodeCard.vue';
import Spinner from '@/components/Spinner.vue';
import { LOAD_STATE } from '@/status';
@Component({
  components: {
    CodeCard,
    Spinner,
  },
})
export default class CodeList extends Vue {
  public mounted() {
    this.$store.dispatch('fetchArts');
  }

  get arts() {
    return this.$store.state.arts;
  }

  get noData() {
    return (
      this.$store.state.status.arts === LOAD_STATE.EMPTY ||
      this.$store.state.status.arts === LOAD_STATE.LOADING
    );
  }

  get isLoading() {
    return this.$store.state.status.arts === LOAD_STATE.LOADING;
  }

  get artsCount() {
    return this.arts.length;
  }

  get modulusSpice() {
    const r = [];
    for (let i = 0; i < this.artsCount; i += 4) {
      r.push(this.arts.slice(i, i + 4));
    }
    return r;
  }
}
